module.exports = __webpack_public_path__ + "img/artboard2.36650ca1.png";